import { merchantApi } from '@/config/axios'

export const getMerchantPoolDraftPage = (params: any) => {
  return merchantApi.get({ url: '/merchant-api/product/pool-draft/page', params })
}

export const pickMerchantPoolDraft = (data: { id: number; deliveryTemplateId?: number }) => {
  return merchantApi.post({ url: '/merchant-api/product/pool-draft/pick', data })
}
